import { ApiResponseType } from '../shared';
import { HttpHandler } from './HttpHandler';
import { environment } from '../enviroments';
import { OnBoardingFlowType } from '@mindly/ui-components';

export const getOnBoardingFlowById = async (
  id: string,
  isTestMode?: boolean
): Promise<ApiResponseType<OnBoardingFlowType>> => {
  const { data: flowData } = await HttpHandler({
    method: 'GET',
    url: `${environment.APP_ONBOARDING_URL}/on-boarding/flow/${id}${isTestMode ? '/true' : ''}`,
  });

  return flowData;
};

export const getDefaultOnBoardingFlowKey = async (
  locale: string
): Promise<ApiResponseType<OnBoardingFlowType & { onboarding_key: string }>> => {
  const { data: flowData } = await HttpHandler({
    method: 'GET',
    url: `${environment.APP_ONBOARDING_URL}/on-boarding/client/flow/default/${locale}`,
  });
  return flowData;
};
